
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipping-policy",
      function () {
        return require("private-next-pages/shipping-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipping-policy"])
      });
    }
  